import { render, staticRenderFns } from "./SelectLayoutModal.vue?vue&type=template&id=4cdbfdc4"
import script from "./SelectLayoutModal.vue?vue&type=script&lang=js"
export * from "./SelectLayoutModal.vue?vue&type=script&lang=js"
import style0 from "./SelectLayoutModal.vue?vue&type=style&index=0&id=4cdbfdc4&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cdbfdc4')) {
      api.createRecord('4cdbfdc4', component.options)
    } else {
      api.reload('4cdbfdc4', component.options)
    }
    module.hot.accept("./SelectLayoutModal.vue?vue&type=template&id=4cdbfdc4", function () {
      api.rerender('4cdbfdc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/SelectLayoutModal.vue"
export default component.exports